import type { LockedFeatureKey } from '../../constants/bloqueios';

// A FRASE DE CADA MÓDULO TRAVADO (decisão do Lucas, 13/10/2026: a direção "C · Palco"). É o título
// do convite: o que o módulo faz, dito como a pessoa diria. Os benefícios continuam os do núcleo
// (`LOCKED_FEATURE_CONFIG`): a promessa comercial é uma só, na web e no app.

export const FRASE_DO_MODULO: Record<LockedFeatureKey, string> = {
  planning: 'O seu diagnóstico vira visão, objetivos e estratégias.',
  plano: 'Cada estratégia vira ações com prazo e responsável.',
  tasks: 'As ações do seu plano, fase a fase.',
  refazer: 'Refaça o diagnóstico e veja a carreira subir de fase.',
  nyta: 'A IA da Maestra, trabalhando dentro do seu perfil.',
  team: 'A sua equipe inteira no mesmo perfil.',
  catalog: 'O seu catálogo inteiro, da guia à faixa lançada.',
  agenda: 'A carreira inteira num calendário só.',
  arquivos: 'Os áudios, capas e materiais da sua carreira num lugar só.',
  negociacoes: 'Cada show que te chamam, do primeiro contato ao sim.',
  shows: 'Cada show fechado, da ficha ao fechamento.',
  cronograma: 'O papel de cada show na mão da banda.',
  perfil: 'A sua página pública, pronta para o Instagram.',
  marketing: 'A sua marca de artista, do arquétipo ao documento.',
};
